var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkspacePublic = function SvgIconWorkspacePublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#3075F6",
    fillOpacity: 0.3,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3075F6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#icon_workspace_public_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.794 9.975a4.81 4.81 0 0 1-4.805 4.81A4.86 4.86 0 0 1 5.211 9.89a4.686 4.686 0 0 1 4.586-4.68 4.764 4.764 0 0 1 4.998 4.767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.797 5.208c-2.5 2.708-2.5 6.242 0 9.575M10.21 5.208c2.5 2.708 2.5 6.24 0 9.574M5.992 7.285h7.973M5.21 9.785h9.583M5.828 12.285h8.375"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_workspace_public_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h10v10H5z"
  })))));
};
export default SvgIconWorkspacePublic;